import type { FC } from 'react';
import type { ModalFooterProps } from '../../types';

const ModalFooter: FC<ModalFooterProps> = ({ onClose, isScheduling, submitError }) => (
  <>
    {submitError && (
      <div className="schedule-meeting-modal__error-box">
        <div className="schedule-meeting-modal__error-banner">
          <strong>{submitError}</strong>
        </div>
      </div>
    )}
    <div className="schedule-meeting-modal__footer">
      <button
        type="button"
        className="schedule-meeting-modal__button schedule-meeting-modal__button--secondary"
        onClick={onClose}
      >
        Cancel
      </button>
      <button
        type="submit"
        className="schedule-meeting-modal__button schedule-meeting-modal__button--primary"
        disabled={isScheduling}
      >
        {isScheduling ? 'Scheduling...' : 'Schedule Meeting'}
      </button>
    </div>
  </>
);

export default ModalFooter;
